import React, {useEffect} from 'react';
import ButtonComponent from '../Components/ButtonComponent';

/**
 * @param {[][]} props.component - 2d array  which contains for every row of a form the inside components
 * @param {setState} props.setComponents - hook method that handle components variable
 * @param {[][]} props.typeFields - 2d array which contains for every row of a form the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {number} props.formRowIndex - index of examined row of a form
 * @param {boolean} props.clickedChangeElement - state that is set to true when component is deleted from variable components
 * @param {setState} props.setClickedAddElement - hook method that handle clickedChangeElement variable
 * @param {boolean} props.openAlert - state that opens/closes edit form pop up 
 * @returns component that represent button inside a row of a form with all the available options for the button ( edit text label, attach method, set target page and href)
 */
const ButtonDataComponent  = (props) =>  {

    const {
        components,
        setComponents,
        typeFields,
        setTypeFields,
        formRowIndex,
        indexComponent,
        clickedChangeElement,
        setClickedChangeElement,
        openAlert
    }= props

    const [anchorEl, setAnchorEl] = React.useState(null); // anchor element of dropdown menu that is used to attach methods to button component
    const [textButton, setTextButton] = React.useState('Send'); // stores text of button
    const [method, setMethod] = React.useState('GET'); // stores attached method to button component 
    const [hrefChecked, setHrefChecked] = React.useState(false); // state if button component has href attached
    const [targetPageChecked , setTargetPageChecked] = React.useState(false); // state if button component has target page attached
    const [href, setHref] = React.useState(''); // attached href to button component
    const [target, setTarget] = React.useState('none'); // attached target page to button component
    const [targets, setTargets] = React.useState(); // names of project's pages 
    const [stateMethod, setStateMethod] = React.useState(false); // opens/closes dropdown menu with attached methods 

    /**
     * This useEffect is runned when edit form pop up is opened for first time to render 
     * button component and it's options (textButton, attached method , href and target page).
     * Also it runs again every time that a component is deleted in order to update correct order of components
     */
    useEffect( () => {
        setTextButton(components[formRowIndex][indexComponent].label); // Render button's text
        setMethod(components[formRowIndex][indexComponent].method); // Render button's attached method

        if(components[formRowIndex][indexComponent].target_page === 'none'){
            setHrefChecked(true);
            setTargetPageChecked(false);
        }
        else{
            setHrefChecked(false);
            setTargetPageChecked(true);
        }

        const selectedProject = localStorage.getItem('selectedProject');
        const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject];
        const tempTargets = [];
        tempData.pages.forEach( (page) => {
            tempTargets.push(page.name);
        })
        setTargets(tempTargets);

    },[clickedChangeElement, openAlert])

    // Update text label of button component
    const handleTextButton = (val) => {
        setTextButton(val.target.value);
        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].label = val.target.value;
        setComponents(tempComponents);
    }

    // Delete button component 
    const deleteComponent = () => {

        // Remove button component from row and update components
        const tempComponents = [...components];
        tempComponents[formRowIndex].splice(indexComponent,1);
        setComponents(tempComponents);

        // Remove button type from row and update typeFields
        const tempTypeFields = [...typeFields];
        tempTypeFields[formRowIndex].splice(indexComponent,1);
        setTypeFields(tempTypeFields);
        setClickedChangeElement(true); // update clickedChangeElements in order to run again useEffect
    } 

    // Update attached method to button component
    const selectMethod = (option) => {
        setAnchorEl(null); // set anchor element of dropdown menu to null
        setStateMethod(false); // close dropdown menu
        setMethod(option); // attach method to dropdown component

        // update method of button component inside components
        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].method = option; 
        setComponents(tempComponents);
    }

    // Attach defined href to button component if href is selected
    const handleHrefChecked = () => {

        const tempComponents = [...components];
        // Assign href to button component inside components
        if(hrefChecked === false){
            setHrefChecked(true);
            setTargetPageChecked(false);
            tempComponents[formRowIndex][indexComponent].href = href;
            tempComponents[formRowIndex][indexComponent].target_page = 'none';
        }
        else{
            setHrefChecked(false);
            tempComponents[formRowIndex][indexComponent].href = '';
        }
        setComponents(tempComponents); // Update components
    }

    // Attach href to button component and set href radio to true if href label is updated
    const handleHref = (val) => {
        setHref(val.target.value); // update href

        // Attach href and remove target page from button component
        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].href = val.target.value;
        tempComponents[formRowIndex][indexComponent].target_page = 'none';
        setHrefChecked(true); // Set href radio to true
        setTargetPageChecked(false); // Set target page radio to false
        setComponents(tempComponents);
    }

    // Attached defined target page if target page radio is selected
    const handleTargetPageChecked = () => {

        const tempComponents = [...components];
        // Attach target page to button component with already defined value and remove href from button component
        if(targetPageChecked === false){
            setTargetPageChecked(true);
            setHrefChecked(false);
            tempComponents[formRowIndex][indexComponent].href = '';
            tempComponents[formRowIndex][indexComponent].target_page = target;
        }
        else{
            setTargetPageChecked(false);
            tempComponents[formRowIndex][indexComponent].target_page = 'none';
        }
        setComponents(tempComponents); // Update components
    }

    // Attach target page and remove href to button component if user updates target page of button 
    const selectTarget = (option) => {
        setTarget(option);

        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].target_page = option;
        tempComponents[formRowIndex][indexComponent].href = '';

        setTargetPageChecked(true);
        setHrefChecked(false);
        setComponents(tempComponents); // update components 
    }

    return( 
            <ButtonComponent
                anchorEl = {anchorEl}
                setAnchorEl = {setAnchorEl}
                deleteComponent = {deleteComponent}
                handleTextButton = {handleTextButton}
                hrefChecked = {hrefChecked}
                handleHrefChecked = {handleHrefChecked}
                handleHref = {handleHref}
                targetPageChecked = {targetPageChecked}
                handleTargetPageChecked = {handleTargetPageChecked}
                href = {href}
                target = {target}
                targets = {targets}
                textButton = {textButton}
                method = {method}
                selectMethod = {selectMethod}
                selectTarget = {selectTarget}
                stateMethod = {stateMethod}
                setStateMethod = {setStateMethod}
            />
    )

}

export default ButtonDataComponent;